import { render, staticRenderFns } from "./ProductExtraExpansionTile.vue?vue&type=template&id=71bd95e0&"
import script from "./ProductExtraExpansionTile.vue?vue&type=script&lang=ts&"
export * from "./ProductExtraExpansionTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports